(() => {
  const MAIN_PRODUCT_SELECTOR = ".shopify-section--main-product";
  const BUY_BUTTONS_SELECTOR =
    '.product-info__block-item[data-block-type="buy-buttons"]';
  const KACHING_SELECTOR = ".kaching-bundles";
  const KACHING_BARS_SELECTOR =
    ".kaching-bundles__bars:not(.kaching-bundles__subscriptions)";
  const SEAL_SUBSCRIPTIONS_SELECTOR = ".sealsubs-container";
  const PURCHASE_OPTIONS_CLASS = "corridge-purchase-options";
  const UNIT_LABEL_CLASS = "corridge-kaching-unit-label";
  const QUANTITY_PARAM = "qty";

  let frameId = null;
  let requestedQuantity = getUrlQuantity();

  function getUrlQuantity() {
    const value = new URL(window.location.href).searchParams.get(QUANTITY_PARAM);
    const match = value?.trim().match(/^(\d+)\s*[x×]?$/i);
    const quantity = Number(match?.[1]);

    return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : null;
  }

  function getBarQuantity(bar) {
    const datasetQuantity = Number(
      bar.dataset.quantity || bar.dataset.dealBarQuantity || bar.dataset.offerQuantity,
    );

    if (Number.isSafeInteger(datasetQuantity) && datasetQuantity > 0) {
      return datasetQuantity;
    }

    const title = bar.querySelector(".kaching-bundles__bar-title")?.textContent;
    const match = (title || bar.textContent).match(/(?:^|\s)(\d+)\s*[x×](?:\s|$)/i);
    const quantity = Number(match?.[1]);

    return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : null;
  }

  function updateQuantityUrl(quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 1) return;

    const url = new URL(window.location.href);
    const value = `${quantity}x`;
    if (url.searchParams.get(QUANTITY_PARAM) === value) return;

    url.searchParams.set(QUANTITY_PARAM, value);
    window.history.replaceState(window.history.state, "", url);
  }

  function applyRequestedQuantity(kachingBundles) {
    if (requestedQuantity === null) return;

    const bars = Array.from(kachingBundles.querySelectorAll(
      `${KACHING_BARS_SELECTOR} .kaching-bundles__bar`,
    ));
    const matchingBar = bars.find((bar) => getBarQuantity(bar) === requestedQuantity);
    if (!matchingBar) return;

    if (!matchingBar.classList.contains("kaching-bundles__bar--selected")) {
      (matchingBar.querySelector(".kaching-bundles__bar-main") || matchingBar).click();
    }

    requestedQuantity = null;
  }

  function styleKachingBadges(kachingBundles) {
    kachingBundles.querySelectorAll(".kaching-bundles__bar").forEach((bar) => {
      const barMain = bar.querySelector(".kaching-bundles__bar-main");
      const radio = bar.querySelector(".kaching-bundles__bar-radio");
      const label = bar.querySelector(".kaching-bundles__bar-label");
      const subtitle = bar.querySelector(".kaching-bundles__bar-subtitle");
      const percentage = subtitle?.textContent.match(/(\d+(?:[,.]\d+)?)\s*%/);

      if (!barMain || !radio || !label) return;

      if (percentage) {
        const badgeText = `-${percentage[1]}%`;

        if (label.textContent !== badgeText) label.textContent = badgeText;
        label.classList.add("corridge-kaching-discount-badge");
        label.classList.remove("corridge-kaching-format-badge");
      } else if (!/^(best|bestseller|most popular)$/i.test(label.textContent.trim())) {
        label.classList.add("corridge-kaching-format-badge");
        label.classList.remove("corridge-kaching-discount-badge");
      }

      if (radio.nextElementSibling !== label) {
        radio.insertAdjacentElement("afterend", label);
      }
    });
  }

  function updateUnitLabel(section, kachingBundles) {
    const productRerender = section.querySelector("product-rerender[data-kaching-unit-label]");
    const bars = kachingBundles.querySelector(KACHING_BARS_SELECTOR);
    const labelText = productRerender?.dataset.kachingUnitLabel?.trim();
    let label = kachingBundles.querySelector(`.${UNIT_LABEL_CLASS}`);

    if (!bars || !labelText) {
      label?.remove();
      return;
    }

    if (!label) {
      label = document.createElement("p");
      label.className = UNIT_LABEL_CLASS;
    }

    if (label.textContent !== labelText) {
      label.textContent = labelText;
    }

    if (label.nextElementSibling !== bars) {
      bars.insertAdjacentElement("beforebegin", label);
    }
  }

  function moveKachingBundles() {
    frameId = null;

    document.querySelectorAll(MAIN_PRODUCT_SELECTOR).forEach((section) => {
      const productInfo = section.querySelector(".product-info");
      const buyButtonsBlock = productInfo?.querySelector(BUY_BUTTONS_SELECTOR);
      const kachingBundles = productInfo?.querySelector(KACHING_SELECTOR);
      const sealSubscriptions = buyButtonsBlock?.querySelector(
        SEAL_SUBSCRIPTIONS_SELECTOR,
      );

      if (!buyButtonsBlock || !kachingBundles) return;

      styleKachingBadges(kachingBundles);
      updateUnitLabel(section, kachingBundles);
      applyRequestedQuantity(kachingBundles);

      if (sealSubscriptions) {
        let purchaseOptions = buyButtonsBlock.querySelector(
          `.${PURCHASE_OPTIONS_CLASS}`,
        );

        if (!purchaseOptions) {
          purchaseOptions = document.createElement("div");
          purchaseOptions.className = PURCHASE_OPTIONS_CLASS;
          sealSubscriptions.insertAdjacentElement("beforebegin", purchaseOptions);
        }

        if (kachingBundles.parentElement !== purchaseOptions) {
          purchaseOptions.append(kachingBundles);
        }

        if (sealSubscriptions.parentElement !== purchaseOptions) {
          purchaseOptions.append(sealSubscriptions);
        }

        return;
      }

      if (buyButtonsBlock.nextElementSibling === kachingBundles) return;

      buyButtonsBlock.insertAdjacentElement("afterend", kachingBundles);
    });
  }

  function scheduleMove() {
    if (frameId !== null) return;
    frameId = window.requestAnimationFrame(moveKachingBundles);
  }

  function keepSelectedBundle(event) {
    const selectedBar = event.target.closest?.(
      `${KACHING_SELECTOR} .kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar--selected`,
    );

    if (!selectedBar || event.target.closest("select, option, a, button, textarea")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function syncClickedBundleToUrl(event) {
    const bar = event.target.closest?.(
      `${KACHING_SELECTOR} ${KACHING_BARS_SELECTOR} .kaching-bundles__bar`,
    );
    if (!bar) return;

    const quantity = getBarQuantity(bar);
    if (quantity === null) return;

    requestedQuantity = null;
    updateQuantityUrl(quantity);
  }

  function handleHistoryNavigation() {
    requestedQuantity = getUrlQuantity();
    scheduleMove();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleMove, { once: true });
  } else {
    scheduleMove();
  }

  new MutationObserver(scheduleMove).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("click", keepSelectedBundle, true);
  document.addEventListener("click", syncClickedBundleToUrl);
  window.addEventListener("popstate", handleHistoryNavigation);
  document.addEventListener("shopify:section:load", scheduleMove);
})();
